module.exports = "/assets/images/skillsphere-logo.png";